import React from 'react';
import { BuyButton } from './BuyButton';
import { SITE } from '../lib/config';
export function Footer() {
  return <footer className="w-full bg-ink py-16 text-cream" data-id="element-41" data-mp="3ggaq1tbg494e">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-42" data-mp="32nulgo2wc31d">
        <p className="font-serif text-xl tracking-[0.35em]" data-id="element-43" data-mp="32pfgsfx1bq0a">{SITE.brand}</p>
        <h2 className="mt-6 font-serif text-3xl italic leading-snug md:text-4xl" data-id="element-44" data-mp="36qhgexuv642s">
          Basta de sostenerlo todo.
        </h2>
        <div className="mt-8 flex justify-center" data-id="element-45" data-mp="3uftm3nqzfu0c">
          <BuyButton variant="solid" size="lg" className="!bg-cream !text-ink hover:!bg-cream-deep" data-id="element-46" data-mp="3990ijjp5eap">
            Quiero mi copia
          </BuyButton>
        </div>
        <p className="mt-12 font-sans text-xs uppercase tracking-[0.2em] text-cream/50" data-id="element-47" data-mp="3qcnh0jflw8vg">
          {SITE.footer}
        </p>
      </div>
    </footer>;
}